<ng-template #router>
    <router-outlet></router-outlet>
</ng-template>
<ng-container *ngIf="!showTabs; else router">
    <invc-loading-error-wrapper [error]="!showTabs">
    </invc-loading-error-wrapper>
</ng-container>